import { render, staticRenderFns } from "./DialogInfoChat.vue?vue&type=template&id=7821bee3&scoped=true&"
import script from "./DialogInfoChat.vue?vue&type=script&lang=js&"
export * from "./DialogInfoChat.vue?vue&type=script&lang=js&"
import style0 from "./DialogInfoChat.vue?vue&type=style&index=0&id=7821bee3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7821bee3",
  null
  
)

export default component.exports